import Layout from "../Components/Layout";
import About from "../Components/About";

function AboutPage() {
    return (
        <Layout>
            <About />
        </Layout>
    )
}

export default AboutPage;